export const googlePlacesApiKey = "AIzaSyDcwP6ei1-J726R-SfIzU999nOvKjsBGhM";
export const googlePlacesDivId = "google_places_tab_results";
